module.exports = __webpack_public_path__ + "static/media/foodo3.f804e90a.png";